/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable multiline-comment-style */
/* eslint-disable @utiljs/utiljs/param-href-limit */
/* eslint-disable @sailor/base-prefer-array-destructuring */
import { Input, Select, Button, TagPro, FormPro } from '@roo/roo'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from '@sailor/i18n-web'
import { useLocation } from 'react-router-dom'
import {
  IStaffInfo,
  IStaffItem,
  getStaffList,
  initAllStaffExport,
  queryExportStatus,
} from '@/pages/staff/common/api'
import { createPolling, downloadFile } from '@/common/utils'
import styles from './index.module.less'
import debounce from 'lodash-es/debounce'
import { failToast } from '@/common/utils/toast'
import CommonTable from '@/components/CommonTable'
import StaffModal from './components/EditStaffModal'
import TipText from '@/components/TipText'
import { useRecoilValue } from 'recoil'
import { loginUserInfo } from '@/common/recoil/atom/userAtom'
import { VerificationTypeEnum } from '@/common/api/api'
import { getI18nTime } from '@/common/utils/i18nFuncs'
import { useRequest } from 'ahooks'
import { fetchGroupList, IGroupItem } from '@/pages/staff/common/groupApi'
import Selector from '@roo/roo/Selector'
import TreeSelect from '@roo/roo0119/TreeSelect'
import ConfigProvider from '@roo/roo0119/ConfigProvider'
import { useDeptTreeSelect, useCostCenterOptions } from '@/hooks'
import entInfoAtom from '@/common/recoil/atom/entInfoAtom'

const STATUS_ENUM = {
  ON_JOB: 2,
  LEAVE: 1,
  ALL: -1,
}

export default () => {
  const { t, ready } = useTranslation()
  const location = useLocation()
  const { adminInfo } = useRecoilValue(loginUserInfo)
  const entInfo = entInfoAtom.useData()
  const [statusFilterVal, setStatusFilterVal] = useState<number>(-1)
  const [data, setData] = useState<any[]>([])
  const [searchVal, setSearchVal] = useState<string>('')
  const [nameVal, setNameVal] = useState<string>('')
  // 账户/姓名搜索框临时値（点击搜索按钮才生效）
  const [accountInput, setAccountInput] = useState<string>('')
  const [nameInput, setNameInput] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [exportLoading, setExportLoading] = useState<boolean>(false)
  const [pageNo, setPageNo] = useState<number>(1)
  const [pageSize, setPageSize] = useState<number>(10)
  const [total, setTotal] = useState<number>(0)
  const searchInputRef = useRef<any>(null)
  const [staffModal, setStaffModal] = useState<undefined | {visible: boolean, record?: IStaffInfo}>()

  // 从 URL query 参数中读取初始部门过滤值
  const getInitDeptId = () => {
    const params = new URLSearchParams(location.search)
    const id = params.get('departmentId')
    return id ? Number(id) : undefined
  }

  // 从 URL query 参数中读取初始成本中心过滤值（从成本中心「查看员工」跳转时传入）
  const getInitCostCenterId = () => {
    const params = new URLSearchParams(location.search)
    const id = params.get('costCenterId')
    return id ? Number(id) : undefined
  }

  const [deptFilterVal, setDeptFilterVal] = useState<number | undefined>(getInitDeptId)
  const [groupFilterVal, setGroupFilterVal] = useState<number | undefined>(undefined)
  const [costCenterFilterVal, setCostCenterFilterVal] = useState<number | undefined>(getInitCostCenterId)

  const [groupKeyword, setGroupKeyword] = useState('')
  const { data: groupListRes, loading: groupOptionsLoading } = useRequest(
    () => fetchGroupList({ pageNo: 1, pageSize: 200, ...(groupKeyword ? { keyword: groupKeyword } : {}) }).then(res => res.data),
    { refreshDeps: [groupKeyword] }
  )
  const handleGroupSearch = useCallback(debounce((kw: string) => setGroupKeyword(kw), 300), [])

  const {
    treeOptions: deptTreeOptions,
    isSearching: isDeptSearching,
    init: initDeptTree,
    reset: resetDeptTree,
    handleSearch: handleDeptSearch,
    handlePopupScroll: handleDeptPopupScroll,
  } = useDeptTreeSelect()

  // 进入员工管理页面时加载一次部门树数据（用于筛选器）
  useEffect(() => {
    initDeptTree()
  }, [])

  const groupOptions: { value: number; label: string }[] = groupOptionsLoading
    ? []
    : (groupListRes?.result || []).map((g: IGroupItem) => ({ value: g.id, label: g.name }))

  // 成本中心选项（costCenterEnabled=true 时懒加载，支持搜索+分页）
  const {
    options: costCenterOptions,
    loading: costCenterOptionsLoading,
    init: initCostCenterOptions,
    handleSearch: handleCostCenterSearch,
    handlePopupScroll: handleCostCenterPopupScroll,
  } = useCostCenterOptions()

  useEffect(() => {
    if (entInfo?.costCenterEnabled) {
      initCostCenterOptions()
    }
  }, [entInfo?.costCenterEnabled])

  const STATUS_TRANSLATION_MAP: { [k: string]: string } = {
    [STATUS_ENUM.ON_JOB]: t('staff_employed', '在职'),
    [STATUS_ENUM.LEAVE]: t('e_pc_leave', '离职'),
    [STATUS_ENUM.ALL]: t('staff_all', '全部'),
  }
  const columns: any = useMemo(() => [
    { dataIndex: 'name',  width: 200, title: t('staff_name', '姓名'), render: (name: string) => <TipText text={name} /> },
    {
      dataIndex: 'email',
      width: 240, title: t('staff_email', '电子邮箱'),
      render: (text: string) => <TipText text={text} />,
    },
    {
      dataIndex: 'status',
      width: 200,
      title: t('staff_status', '状态'),
      render: (status: number, record: IStaffItem) => {
        const statusLabel = STATUS_TRANSLATION_MAP[status]
        return status === STATUS_ENUM.LEAVE ? (
          <TagPro mode="light" color="#CCCCCC" shape="round">{statusLabel}</TagPro>
        ) : (
          <div >
            <TagPro color={'success'} shape="round">{statusLabel}</TagPro>
            {((record.scheduledResignTime || 0) > 0) && (<TipText
              style={{ fontSize: '12px', color: '#ff8800' }}
              text={t('e_pc_resign_alert', { resigntime: getI18nTime(record.scheduledResignTime as number)  })}
            />)}
          </div>
        )
      },
    },
    {
      dataIndex: 'departmentNamePath',
      title: t('staff_department', '部门'),
      width: 240,
      render: (text: string) => <TipText text={text || '--'} />,
    },
    {
      dataIndex: 'groups',
      title: t('e_pc_group_common', '分组'),
      width: 240,
      render: (groups: { id: number; name: string }[]) => {
        if (!groups?.length) return '--'
        return <TipText text={groups.map(g => g.name).join('、')} />
      },
    },
    {
      dataIndex: 'employeeNum',
      title: t('e_pc_staff_id', '工号'),
      width: 200,
      render: (text:string) => <TipText text={text || '--'} />,
    },
    entInfo?.costCenterEnabled && {
      dataIndex: 'costCenterName',
      title: t('e_pc_cost_center_tab', '成本中心'),
      width: 200,
      render: (text: string) => <TipText text={text || '--'} />,
    },
    adminInfo?.activityCreation && !adminInfo?.verificationTypes.includes(VerificationTypeEnum.EMAIL)
      ? {
        dataIndex: 'phone',
        width: 240, title: t('ent_o_contact_form_phone_label', '電話號碼'),
        render: (maskedPhone: string) => <TipText text={maskedPhone} />   }
      : null,
    {
      title: t('batch_common_operation', '操作'),
      width: 120,
      fixed: 'right',
      align: 'center',
      render: (_: never, record: any) => (
        <div>
          <Button type="brand-text" onClick={() => setStaffModal({ visible: true, record })}>
            {t('e_pc_edit', '编辑')}
          </Button>
        </div>
      ),
    },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ], [ready, entInfo?.costCenterEnabled, adminInfo?.activityCreation, adminInfo?.verificationTypes])

  const handleSearch = () => {
    setPageNo(1)
    setSearchVal(accountInput.trim())
    setNameVal(nameInput.trim())
  }

  const handleReset = () => {
    setAccountInput('')
    setNameInput('')
    setStatusFilterVal(STATUS_ENUM.ALL)
    setDeptFilterVal(undefined)
    setGroupFilterVal(undefined)
    setCostCenterFilterVal(undefined)
    setPageNo(1)
    setSearchVal('')
    setNameVal('')
  }

  const fetchTableData = async () => {
    setLoading(true)
    const params = {
      pageNo,
      pageSize,
      staffStatusList: JSON.stringify(
        statusFilterVal === STATUS_ENUM.ALL
          ? [STATUS_ENUM.LEAVE, STATUS_ENUM.ON_JOB]
          : [statusFilterVal]
      ),
      keyword: searchVal ? searchVal.trim() : '',
      name: nameVal ? nameVal.trim() : '',
      needDepartmentNamePath: true,
      needDepartmentInfo: true,
      departmentId: deptFilterVal,
      groupId: groupFilterVal,
      costCenterId: costCenterFilterVal,
    }
    const res = await getStaffList(params)
    const { success, data } = res
    if (success) {
      const { result = [], totalCount = 0 } = data || {}
      setData(result)
      setTotal(totalCount)
    }
    setLoading(false)
  }
  useEffect(() => {
    fetchTableData()
  }, [pageNo, pageSize, statusFilterVal, searchVal, nameVal, deptFilterVal, groupFilterVal, costCenterFilterVal])

  const handlePageChange = (_pageNo: number, _pageSize: number) => {
    _pageNo !== pageNo && setPageNo(_pageNo)
    _pageSize !== pageSize && setPageSize(_pageSize)
  }

  const handleBatchUpdate = () => {
    window.open(`${window.location.href.split('#')[0]}#/staff/batchUpdate`)
  }

  const handleSearchOnBlur = () => {
    const newSearchVal = searchInputRef.current?.value
    if (newSearchVal !== searchVal) {
      updateSearchVal(newSearchVal)
    }
  }
  const handleOnKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const { key, target } = event || {}
    if (key === 'Enter') {
      const val = (target as HTMLInputElement).value
      const trimmedVal = val ? val.trim() : ''
      updateSearchVal(trimmedVal)
    }
  }

  const handleStaffExport = async () => {
    if (exportLoading) {
      return
    }
    setExportLoading(true)
    const initRes = await initAllStaffExport()
    const { success, data: token } = initRes
    if (success && token) {
      createPolling({
        requestFunction: async () => queryExportStatus({ token }),
        checkSuccess: (response) => response.data.code === 30,
        onSuccess: (response) => {
          const { downLoadUrl } = response.data || {}
          const regex = /\/([^?#]+\.xlsx)(?:\?|#|$)/i
          // 使用正则表达式匹配
          const match = downLoadUrl.match(regex)
          const fileName = match[1]
          downloadFile({
            url: downLoadUrl,
            fileName,
          })
          setExportLoading(false)
        },
        checkError: (response) => response?.success === false || response?.data?.code === 40,
        onError: (error) => {
          if (error?.success && error.data.code === 40) {
            failToast(error.data.message)
          }
          setExportLoading(false)
        },
      })
    } else {
      setExportLoading(false)
    }
  }

  const debouncedHandleExport = debounce(handleStaffExport, 300)
  const updateSearchVal = (val: string) => {
    setPageNo(1)
    setSearchVal(val)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      {/* 筛选区：CSS Grid 布局，4 列等分，gap 12px，彻底绕开 Row 负边距问题 */}
      <FormPro layout="vertical" size="small" labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}>
        <div className={styles.filterGrid} style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0 12px' }}>
          {/* 第一行：账户 / 姓名 / 状态 / 部门 */}
          <FormPro.Item label={t('e_pc_account_placeholder', '账户（邮箱/手机号）')} style={{ marginBottom: 8 }}>
            <Input
              allowClear
              value={accountInput}
              placeholder={t('e_pc_input_account_hint', '请输入邮箱或手机号')}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAccountInput(e.target.value)}
              onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {if (e.key === 'Enter') handleSearch()}}
            />
          </FormPro.Item>
          <FormPro.Item label={t('staff_name', '姓名')} style={{ marginBottom: 8 }}>
            <Input
              allowClear
              value={nameInput}
              placeholder={t('e_pc_input_staff_name', '请输入员工姓名')}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNameInput(e.target.value)}
              onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {if (e.key === 'Enter') handleSearch()}}
            />
          </FormPro.Item>
          <FormPro.Item label={t('staff_status', '员工状态')} style={{ marginBottom: 8 }}>
            <Select
              value={statusFilterVal}
              onChange={(val) => setStatusFilterVal(val)}
              options={[
                { value: STATUS_ENUM.ALL, label: STATUS_TRANSLATION_MAP[STATUS_ENUM.ALL] },
                { value: STATUS_ENUM.ON_JOB, label: STATUS_TRANSLATION_MAP[STATUS_ENUM.ON_JOB] },
                { value: STATUS_ENUM.LEAVE, label: STATUS_TRANSLATION_MAP[STATUS_ENUM.LEAVE] },
              ]}
            />
          </FormPro.Item>
          <ConfigProvider config={{ prefixCls: 'roo0119' }}>
            <FormPro.Item label={t('e_pc_dept_label', '部门')} style={{ marginBottom: 8 }}>
              <div className={styles.deptTreeSelectWrap}>
                <TreeSelect
                  useNew
                  value={deptFilterVal}
                  treeData={deptTreeOptions}
                  treeDefaultExpandAll={isDeptSearching}
                  placeholder={t('e_pc_select_dept_placeholder', '请选择或搜索部门')}
                  showSearch={{ onSearch: handleDeptSearch }}
                  onChange={(val) => {
                    setDeptFilterVal(val as number | undefined)
                    if (val === null || val === undefined) resetDeptTree()
                  }}
                  onPopupScroll={handleDeptPopupScroll}
                  allowClear
                />
              </div>
            </FormPro.Item>
          </ConfigProvider>
          {/* 第二行：分组（占 1 列）+ 成本中心（1 列，costCenterEnabled=true 时显示）+ 按钮区（居右对齐） */}
          <FormPro.Item label={t('e_pc_group_label', '分组')} style={{ marginBottom: 8 }}>
            <Selector
              clearable
              filterable
              filterMethod={() => true}
              value={groupFilterVal}
              placeholder={t('e_pc_select_group_placeholder', '请选择或搜索分组')}
              onChange={(val: number) => setGroupFilterVal(val)}
              options={groupOptions}
              onSearch={handleGroupSearch}
              className={styles.selectorFix}
            />
          </FormPro.Item>
          {entInfo?.costCenterEnabled && (
            <FormPro.Item label={t('e_pc_cost_center_tab', '选择成本中心')} style={{ marginBottom: 8 }}>
              <Selector
                clearable
                filterable
                filterMethod={() => true}
                value={costCenterFilterVal}
                placeholder={t('e_pc_cost_center_input', '请选择或搜索成本中心')}
                onChange={(val: number) => setCostCenterFilterVal(val)}
                options={costCenterOptions}
                loading={costCenterOptionsLoading}
                onSearch={handleCostCenterSearch}
                onPopupScroll={handleCostCenterPopupScroll}
                className={styles.selectorFix}
              />
            </FormPro.Item>
          )}
          <div className={styles.actionColRight} style={{ gridColumn: entInfo?.costCenterEnabled ? 'span 2' : 'span 3' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: 8 }}>
              <Button type="hollow" size="normal" htmlType="button" onClick={handleReset}>
                {t('e_pc_reset', '重置')}
              </Button>
              <Button type="brand" size="normal" htmlType="button" onClick={handleSearch} className="btn-dark">
                {t('e_pc_aquire', '查询')}
              </Button>
            </div>
          </div>
        </div>
      </FormPro>
      {/* 操作行：批量修改居左，导出全部 + 创建员工居右，位于搜索区与表格之间 */}
      <div className={styles.actionBar} style={{ marginTop: 16 }}>
        <Button type="hollow" onClick={handleBatchUpdate}>
          {t('staff_batch_update', '批量修改')}
        </Button>
        <div className={styles.actionBarRight}>
          <Button
            className={styles.actionBarSecondaryBtn}
            loading={exportLoading}
            onClick={debouncedHandleExport}

          >
            {t('staff_common_export', '导出全部')}
          </Button>
          <Button type="brand" onClick={() => setStaffModal({ visible: true })}>
            {t('e_pc_create_staff', '创建员工')}
          </Button>
        </div>
      </div>
      <CommonTable
        style={{ marginTop: 20 }}
        rowKey="staffId"
        columns={columns}
        data={data}
        loading={loading}
        pagination={{
          total,
          currentPage: pageNo,
          pageSize: pageSize,
          onChange: handlePageChange,
        }}
      />
      <StaffModal
        visible={staffModal?.visible}
        record={staffModal?.record}
        onSuccess={() => {
          setStaffModal(undefined)
          fetchTableData()
        }} onClose={() => {setStaffModal(undefined)}}/>
    </div>
  )
}
